import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import YMRSList from "../pages/Phase-04/YMRS/YMRSList";
import {
  fetchYmrsAssessments,
  deleteYmrsAssessment,
  setCurrentYmrsAssessment,
  clearCurrentYmrsAssessment,
  clearError
} from "../store/slices/ymrsAssessmentsSlice";

const YMRS = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { ymrsAssessments, currentYmrsAssessment, error, isLoading } = useSelector(
    (state) => state.ymrsAssessments
  );

  useEffect(() => {
    dispatch(fetchYmrsAssessments());
  }, [dispatch]);

  const handleAdd = () => {
    dispatch(clearCurrentYmrsAssessment());
    navigate("/phase04/ymrs/add");
  };

  const handleEdit = (id) => {
    const assessment = ymrsAssessments.find((a) => a.id === id);
    dispatch(setCurrentYmrsAssessment(assessment));
    navigate(`/phase04/ymrs/edit/${id}`);
  };

  const handleDelete = (id) => {
    dispatch(deleteYmrsAssessment(id));
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-body p-0">
            <YMRSList
              assessments={ymrsAssessments}
              onAdd={handleAdd}
              onEdit={handleEdit}
              onDelete={handleDelete}
              isLoading={isLoading}
              error={error}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default YMRS;
